import { toast } from "react-toastify";

/**
 * @param {Error|Object} error
 * @param {string} defaultMessage
 * @param {Function} t
 */
export const showErrorToast = (error, defaultMessage = null, t = null) => {
  let errorMessage = defaultMessage || "Une erreur est survenue";

  if (error?.response?.data?.message) {
    errorMessage = error.response.data.message;
  } else if (error?.response?.data?.error) {
    errorMessage = error.response.data.error;
  } else if (error?.message) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  if (t && typeof errorMessage === "string") {
    errorMessage = t(errorMessage) || errorMessage;
  }

  errorMessage = formatErrorMessage(errorMessage);

  toast.error(errorMessage, {
    className: "custom-toast",
    autoClose: 5000,
  });

  if (process.env.NODE_ENV === "development") {
    console.error("Error details:", error);
  }
};

/**
 * @param {string} message
 * @param {Function} t
 */
export const showSuccessToast = (message, t = null) => {
  const translatedMessage = t ? t(message) || message : message;
  toast.success(translatedMessage, {
    className: "custom-toast",
    autoClose: 2500,
  });
};

function formatErrorMessage(message) {
  const errorMappings = {
    "Network Error": "Erreur de connexion. Vérifiez votre connexion internet.",
    "Request failed with status code 404":
      "La ressource demandée n'a pas été trouvée.",
    "Request failed with status code 500":
      "Erreur serveur. Veuillez réessayer plus tard.",
    "Request failed with status code 401":
      "Session expirée. Veuillez vous reconnecter.",
    "Request failed with status code 403":
      "Vous n'avez pas les droits nécessaires pour cette action.",
    timeout: "La requête a pris trop de temps. Veuillez réessayer.",
    "Cannot read properties of null": "Données manquantes ou invalides.",
    "Cannot read properties of undefined": "Données manquantes ou invalides.",
  };

  for (const [technical, userFriendly] of Object.entries(errorMappings)) {
    if (message.includes(technical)) {
      return userFriendly;
    }
  }

  if (message.length > 200) {
    return message.substring(0, 197) + "...";
  }

  return message;
}
